<template>
    <div>
        <div class="bg-white rounded">
            <h3 class="font-weight-bold px-3 f-20 pt-4 text-left mb-3 text-black">{{ $t('settings.title') }}</h3>
            <b-form class="pb-3 px-3">
                <b-row class="mt-2">
                    <b-col lg="7" md="12" sm="12">
                        <b-row class="text-left mb-3">
                            <b-col sm="12" class="my-auto">
                                <p class="font-weight-bold mb-2">{{ $t('settings.companyIdSection') }}</p>
                                <label>{{ $t('settings.companyIdLabel') }}</label>
                            </b-col>
                            <b-col sm="12">
                                <div class="d-flex align-items-center position-relative">
                                    <b-form-input v-model="company[0].company_ID" disabled></b-form-input>
                                    <svg v-if="allowUpdateSettings" @click="$bvModal.show('modal-company-id')"
                                        class="edit-company-id cursor-pointer" width="18" height="18" viewBox="0 0 18 18"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                            fill="#2CCE89" />
                                    </svg>

                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="my-3">
                    <b-col lg="7" md="12" sm="12">
                        <b-row class="text-left mb-3">
                            <b-col sm="12" class="my-auto">
                                <p class="font-weight-bold mb-2">{{ $t('settings.companyEquipmentPortal') }}</p>
                                <label>{{ $t('settings.companyPathLabel') }}</label>
                            </b-col>
                            <b-col sm="12" class="d-flex align-items-center">
                                <b-form-input v-model="companyPath" :placeholder="$t('settings.companyPathPlaceholder')" readonly
                                    @click="copyURL(companyPath)"></b-form-input>
                                <b-button v-if="allowUpdateSettings && companyPath" variant="primary" class="ml-2 h-40px"
                                    @click="generateCompanyQRCode(company[0].name + '-qrcode', qrCodeUrl)">{{ $t('settings.qr') }}</b-button>
                            </b-col>
                        </b-row>
                        <!-- <b-row class="text-left mb-2">
                            <b-col sm="12" class="my-auto">
                                <label>Company PIN:</label>
                            </b-col>
                            <b-col sm="12">
                                <b-form-input v-model="company[0].pin_code" placeholder="Enter Pin Code"
                                    :disabled="!allowUpdateSettings"></b-form-input>
                            </b-col>
                        </b-row> -->

                    </b-col>
                </b-row>
                <b-row class="my-3">
                    <b-col lg="7" md="12" sm="12">
                        <p class="mb-2 font-weight-bold text-left">{{ $t('settings.models') }}</p>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.maintenance') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.maintenanceDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showMaintenance" name="check-button" switch size="lg"
                                    class="-mr-12px" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.safety') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.safetyDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showSafety" name="check-button" switch size="lg" class="-mr-12px"
                                    :disabled="!allowUpdateSettings" @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.recruiting') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.recruitingDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showRecruiting" name="check-button" switch size="lg" class="-mr-12px"
                                    :disabled="!allowUpdateSettings" @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                         <!-- <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.aiChat') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.aiChatDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showAIChat" name="check-button" switch size="lg" class="-mr-12px"
                                    :disabled="!allowUpdateSettings" @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.task') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.taskDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showTask" name="check-button" switch size="lg" class="-mr-12px"
                                    :disabled="!allowUpdateSettings" @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row> -->
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.vault') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.vaultDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="showVault" name="check-button" switch size="lg" class="-mr-12px"
                                    :disabled="!allowUpdateSettings" @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <!-- <hr class="mt-2" /> -->
                <b-row class="my-3">
                    <b-col lg="7" md="12" sm="12">
                        <p class="mb-2 font-weight-bold text-left">{{ $t('settings.required') }}</p>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.docTypeRequired') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.docTypeRequiredDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="docTypeRequired" name="check-button" switch size="lg"
                                    class="-mr-12px" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.divisionRequired') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.divisionRequiredDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="isDivisionRequired" name="check-button" switch size="lg"
                                    class="-mr-12px" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                 <b-row class="my-3">
                    <b-col lg="7" md="12" sm="12">
                        <p class="mb-2 font-weight-bold text-left">{{ $t('settings.workflow') }}</p>
                        <b-row class="mb-0">
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.autoExtractDotInspection') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.autoExtractDotInspectionDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].auto_extract_dot_inspection" name="check-button" switch size="lg"
                                    class="-mr-12px" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.sendDvirDailyReminders') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.sendDvirDailyRemindersDesc') }}</p>
                                </div>
                                <b-form-checkbox v-model="company[0].send_dvir_daily_reminders" name="check-button" switch size="lg"
                                    class="-mr-12px" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-checkbox>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                            <!-- How far out the bot sets an annual inspection to
                                 expire, rather than on or off. -->
                            <b-col sm="12" class="text-left d-flex align-items-center justify-content-between">
                                <div>
                                    <label class="text-left w-fit-content mb-0">{{ $t('settings.annualInspectionBot') }}</label>
                                    <p class="mb-0 text-grey f-12">{{ $t('settings.annualInspectionBotDesc') }}</p>
                                </div>
                                <b-form-select v-model="company[0].annual_inspection_expiry_frame" class="f-12 w-auto"
                                    :options="expiryFrameOptions" :disabled="!allowUpdateSettings"
                                    @change="updateCompanyData"></b-form-select>
                            </b-col>
                            <b-col sm="12">
                                <hr class="w-100 mt-2" />
                            </b-col>
                        </b-row>
                        </b-col>
                        </b-row>
                <b-row class="my-3" v-if="showMaintenance">
                    <b-col lg="7" md="12" sm="12">
                        <p class="mb-2 font-weight-bold text-left">{{ $t('settings.dotInspect') }}</p>
                        <b-col sm="12" class="text-left px-0">
                            <label class="text-left">{{ $t('settings.inspectionSiteLabel') }}</label>
                            <b-form-input v-model="company[0].inspection_site_name"
                                :placeholder="$t('settings.inspectionSitePlaceholder')"></b-form-input>
                        </b-col>
                        <b-col sm="12" class="text-left px-0 mt-3">
                            <label class="text-left">{{ $t('settings.inspectorNameLabel') }}</label>
                            <b-form-input v-model="company[0].inspector_default_name"
                                :placeholder="$t('settings.inspectorNamePlaceholder')"></b-form-input>
                        </b-col>
                    </b-col>
                </b-row>
                <b-row class="mt-4" v-if="hasChanged">
                    <b-col lg="7" md="12" sm="12" class="d-flex justify-content-end">
                        <b-button variant="primary" @click="updateCompanyData" class="h-40px w-100px">{{ $t('settings.save') }}</b-button>
                    </b-col>

                </b-row>
            </b-form>
            <qriously class="d-none" v-if="allowUpdateSettings"
                :value="'https://app.digitalpermitbook.com/company/' + company[0].path" :size="200" ref="qrcode" />
        </div>
        <CompanyId v-if="allowUpdateSettings" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import generateQRCode from "../../services/generateCompanyQRCode.js";
import { checkValueExists } from "../../services/helper";
import CompanyId from "./CompanyId.vue";
export default {
    name: "Settings",
    components: { CompanyId },
    data() {
        return {
            checkValueExists,
            qrCodeUrl: "",
            showMaintenance: false,
            showTask: false,
            showVault: false,
            showRecruiting: false,
            showFileDrop: false,
            showAIChat: false,
            showSafety: false,
            docTypeRequired: false,
            isDivisionRequired: false,
            defaultData: {}
        }
    },
    methods: {
        ...mapActions(["updateCompany", 'setNotification', "getAllCountries", "setLoader"]),
        generateCompanyQRCode(fileName, qrCode) {
            generateQRCode(this.company[0].name, fileName, qrCode)
        },
        async copyURL(url) {
            if (url) {
                try {
                    await navigator.clipboard.writeText(url);
                    await this.setNotification({
                        msg: this.$t('settings.companyPathCopied'),
                        type: "success",
                        color: "green",
                    });
                } catch (e) {
                    console.log(e)
                }
            }
        },
        payloadToFormData(payload) {
            let formData = new FormData();
            for (let [key, value] of Object.entries(payload)) {
                if (key === "logo" && this.companyLogo) {
                    formData.append(key, this.companyLogo, this.companyLogo.name);
                } else if (key !== "logo") {
                    if (value !== null) {
                        formData.append(key, value);
                    }
                }
            }
            return formData;
        },
        async updateCompanyData() {
            try {
                this.setLoader(true)
                let companyData = {
                    ...this.company[0],
                    state: this.company[0].state.id,
                    show_maintenance: this.showMaintenance,
                    show_task: this.showTask,
                    show_vault: this.showVault,
                    show_file_drop: this.showFileDrop,
                    show_safety: this.showSafety,
                    show_recruiting: this.showRecruiting,
                    ...this.showSafety ? {} : { show_accident: false },
                    ...this.show_maintenance ? {} : { show_driver_maintenance: false },
                    ai_docs: this.showAIChat,
                    doc_type: this.docTypeRequired,
                    is_division_required: this.isDivisionRequired,
                    company_id: this.userCompany,
                    inspector_default_name: this.company[0].inspector_default_name,
                    inspection_site_name: this.company[0].inspection_site_name,
                    auto_extract_dot_inspection: this.company[0].auto_extract_dot_inspection,
                    send_dvir_daily_reminders: this.company[0].send_dvir_daily_reminders
                };
                const formData = this.payloadToFormData(companyData);
                this.defaultData = JSON.parse(JSON.stringify({
                    inspector_default_name: this.company[0].inspector_default_name,
                    inspection_site_name: this.company[0].inspection_site_name
                }))
                const updatedCompany = await this.updateCompany({
                    id: `${this.userCompany}`,
                    payload: formData,
                });
                if (updatedCompany) {
                    this.company[0] = updatedCompany;
                    await this.setNotification({
                        msg: this.$t('settings.updated', { name: this.company[0].name }),
                        type: "success",
                        color: "green",
                    });
                }
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        }
    },
    computed: {
        ...mapGetters(['company', "userCompany", 'rolePermissions']),
        // How long an annual inspection the bot files stays valid for.
        expiryFrameOptions() {
            return [
                { value: '3 mo', text: '3 MO' },
                { value: '6 mo', text: '6 MO' },
                { value: '1 yr', text: '1 YR' },
                { value: '2 yr', text: '2 YR' },
                { value: '3 yr', text: '3 YR' },
                { value: '4 yr', text: '4 YR' },
                { value: '5 yr', text: '5 YR' },
            ];
        },
        hasChanged() {
            return Object.keys(this.company[0]).filter(field => {
                if(field === 'inspector_default_name' || field === 'inspection_site_name') {
                    return this.checkValueExists(this.company[0][field]) != this.checkValueExists(this.defaultData[field])
                } return false
            }).length > 0
        },
        allowUpdateSettings() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'] && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
        companyPath() {
            return this.company[0].path ? `${process.env.VUE_APP_APP_URL}company/${this.company[0].path}` : ''
        },
    },
    watch: {
        company: {
            async handler() {
                await this.$nextTick()
                this.showMaintenance = this.company[0].show_maintenance
                this.showTask = this.company[0].show_task
                this.showVault = this.company[0].show_vault
                this.showFileDrop = this.company[0].show_file_drop
                this.showSafety = this.company[0].show_safety
                this.showRecruiting = this.company[0].show_recruiting
                this.docTypeRequired = this.company[0].doc_type
                this.showAIChat = this.company[0].ai_docs
                this.isDivisionRequired = this.company[0].is_division_required
                this.defaultData = JSON.parse(JSON.stringify({
                    inspector_default_name: this.company[0].inspector_default_name,
                    inspection_site_name: this.company[0].inspection_site_name
                }))
                if (this.allowUpdateSettings)
                    this.qrCodeUrl =
                        this.$refs?.qrcode.qrious._canvasRenderer.element.toDataURL();
            },
            immediate: true,
        }
    }
}
</script>
<style>
.edit-company-id {
    position: absolute;
    right: 10px;
    z-index: 10;
}
</style>